import React, { useState, useEffect } from 'react';
import { RiArrowDropDownLine, RiSearchLine, RiShoppingCartLine, RiMenuLine } from "react-icons/ri";
import { Link, useLocation } from 'react-router-dom';
import { RxCross2 } from "react-icons/rx";

const Navbar = () => {
  const [activeLink, setActiveLink] = useState('');
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/') {
      setActiveLink('home');
    } else if (location.pathname === '/about-us') {
      setActiveLink('aboutUs');
    } else if (location.pathname === '/service') {
      setActiveLink('services');
    } else if (location.pathname === '/courses') {
      setActiveLink('courses');
    } else if (location.pathname === '/consult') {
      setActiveLink('consults');
    } else if (location.pathname === '/blog') {
      setActiveLink('blog');
    } else if (location.pathname === '/contact') {
      setActiveLink('contacts');
          } else if (location.pathname === '/login') {
      setActiveLink('login');
    }
  }, [location]);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    if (isMobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav className="custom-padding xl-screen-padding bg-white border-b shadow-sm sticky top-0 z-50">
      <div className="mx-auto py-2 flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center justify-between w-full md:w-auto">
          <div className="md:hidden">
            {isMobileMenuOpen ? (
              <RxCross2
                onClick={() => setMobileMenuOpen(false)}
                className="text-2xl cursor-pointer"
              />
            ) : (
              <RiMenuLine
                onClick={() => setMobileMenuOpen(true)}
                className="text-2xl cursor-pointer"
              />
            )}
          </div>

          <div className="flex items-center space-x-4">
            <Link to="/" className="flex items-center">
              <img src={require('../../src/assets/images/newlogo.png')}
                alt="Logo" className="h-auto w-[125px]" />
            </Link>
          </div>

          <div className="flex items-center space-x-4 md:hidden">
            <div className="flex items-center justify-center bg-gray-100 rounded-full">
              <Link to="#" className="text-gray-700 hover:text-[#6DBE45]">
                <RiSearchLine className="text-lg" />
              </Link>
            </div>
            <div className="flex items-center justify-center bg-gray-100 rounded-full">
              <Link to="#" className="text-gray-700 hover:text-[#6DBE45]">
                <RiShoppingCartLine className="text-lg" />
              </Link>
            </div>
          </div>
        </div>

        <div className={`fixed inset-0 bg-black bg-opacity-60 z-40 md:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`} onClick={() => setMobileMenuOpen(false)}></div>

        <div className={`fixed top-0 left-0 h-full bg-white z-50 transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} w-3/4`}>
          <div className="flex flex-col space-y-6 py-6 px-8">
            <div className="flex justify-between items-center">
              <Link
                to="/"
                className={`font-lato text-lg ${activeLink === 'home' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
                onClick={() => handleLinkClick('home')}
              >
                Home
              </Link>
              <RxCross2
                onClick={() => setMobileMenuOpen(false)}
                className="text-2xl cursor-pointer"
              />
            </div>

            <Link
              to="/about-us"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'aboutUs' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('aboutUs')}
            >
              About Us
            </Link>

            <Link
              to="/service"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'services' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('services')}
            >
              Services
            </Link>


            {/* <Link
              to="/courses"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'courses' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('courses')}
            >
              Courses
            </Link> */}

            <Link
              to="/consult"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'consults' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('consults')}
            >
              Consults
            </Link>

            <Link
              to="/blog"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'blog' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('blog')}
            >
              Blog
            </Link>

            <Link
              to="/contact"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'contacts' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('contacts')}
            >
              Contact Us
            </Link>
              {/* <Link
              to="/login"
              className={`font-lato text-lg hover:text-[#6DBE45] ${activeLink === 'login' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
              onClick={() => handleLinkClick('login')}
            >
              Login
            </Link> */}
          </div>
        </div>

        <div className="hidden md:flex md:w-auto md:flex-row md:space-x-8 items-center mt-4 md:mt-0">
          <Link
            to="/"
            className={`font-lato text-sm ${activeLink === 'home' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
            onClick={() => handleLinkClick('home')}
          >
            Home
          </Link>

          <div className="relative">
            <Link
              to="/about-us"
              className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'aboutUs' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
              onClick={() => handleLinkClick('aboutUs')}
            >
              About Us
            </Link>
          </div>

          <div className="relative">
            <Link
              to="/service"
              className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'services' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
              onClick={() => handleLinkClick('services')}
            >
              Services
            </Link>
          </div>
{/* 
          <Link
            to="/courses"
             className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'courses' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold`}
            onClick={() => handleLinkClick('courses')}
          >
            Courses
          </Link> */}


          <div className="relative">
            <Link
              to="/consult"
              className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'consults' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
              onClick={() => handleLinkClick('consults')}
            >
              Consult
            </Link>
          </div>

          <div className="relative">
            <Link
              to="/blog"
              className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'blog' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
              onClick={() => handleLinkClick('blog')}
            >
              Blogs
            </Link>
          </div>

          <div className="relative">
            <Link
              to="/contact"
              className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'contacts' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
              onClick={() => handleLinkClick('contacts')}
            >
              Contact Us
            </Link>
          </div>
             {/* <div className="relative">
            <Link
              to="/login"
              className={`font-lato text-sm hover:text-[#6DBE45] ${activeLink === 'login' ? 'text-[#6DBE45]' : 'text-gray-700'} font-semibold flex items-center`}
              onClick={() => handleLinkClick('login')}
            >
              Login
            </Link>
          </div> */}
        </div>

        <div className="flex space-x-4 items-center justify-end w-full md:w-auto md:mt-0 hidden md:flex">
          <div className="flex items-center justify-center bg-gray-100 rounded-full w-8 h-8">
            <Link to="#" className="text-gray-700 hover:text-[#6DBE45]">
              <RiSearchLine className="text-lg" />
            </Link>
          </div>
          <div className="flex items-center justify-center bg-gray-100 rounded-full w-8 h-8">
            <Link to="#" className="text-gray-700 hover:text-[#6DBE45]">
              <RiShoppingCartLine className="text-lg" />
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
